<template>
  <div class="job-profile-limited-content">
    <div
      class="d-flex flex-column ga-1 pa-6 border-b-sm"
    >
      <div class="text-h1 text-textDarkest">
        {{ jobProfile?.title }}
      </div>

      <div class="d-flex ga-4">
        <div
          v-if="jobProfile?.title"
          class="d-flex my-auto"
        >
          <JobProfileStatus
            :is-hris-profile="isHrisProfile"
            :status="jobProfile?.status"
            :is-template="isTemplate"
          />
        </div>

        <div
          v-if="infoElements.length > 0"
          class="text-body-3 text-textLight d-flex ga-1 my-auto"
        >
          <div
            v-for="info in infoElements"
            :key="info"
          >
            {{ info }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="pa-6"
    >
      <div
        v-for="(field, i) in nonEmptyFields"
        :key="field.id"
      >
        <v-divider
          v-if="i > 0"
          class="opacity-100 mt-3 mb-4"
        />

        <div class="text-body-1 text-textDarkest mb-1">
          {{ field.label }}
        </div>

        <DocumentPreviewFieldHtml :html="field.html" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import DocumentPreviewFieldHtml from '@ui/components/general/DocumentPreviewFieldHtml/DocumentPreviewFieldHtml.vue';
import JobProfileStatus from './JobProfileStatus.vue';

const {
  jobProfile, nonEmptyFields, isTemplate, isHrisProfile,
} = storeToRefs(useCurrentJobProfile());

// take values of department, location and job_code refs,
// remove empty ones and add dot delimiter between each of them
const infoElements = computed(() => [
  jobProfile.value?.department,
  jobProfile.value?.location,
  jobProfile.value?.job_code,
]
  .filter(Boolean)
  .flatMap((v) => ['·', v])
  .slice(1));
</script>
